import { SortOrder } from "antd/es/table/interface";
import { ReactNode } from "react";
import { components } from "types/openapi";
import { TBidDto } from "./bids";

export type FeeEntity = components["schemas"]["SetSettingsRequest"];
export type RateEntity = components["schemas"]["UpdateRateDto"];

export type ItemInfoType =
  | {
      label: ReactNode | string;
      text: ReactNode | string;
      width?: number;
      key?: any;
      id?: string;
    }
  | null
  | undefined;
export interface DataType {
  id: string;
  traderId: string;
  currencyFrom: string;
  currencyFromQty: number;
  currencyTo: string;
  currencyToQty: number;
  rate: number;
  status: ORDER_STATUS;
  traderAccount: string;
  exchangerAccount: string;
  created: null | string;
}

export interface OperatorDataType extends DataType {
  operationType: "SELL" | "BUY";
  amlStatus: AML_STATUS;
  transactionHash: string;
  comment: string;
  modified: string;
  traderId: string;
}

export enum ORDER_STATUS {
  NEW = "NEW",
  PROCESSING = "PROCESSING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export enum AML_STATUS {
  NEW = "NEW",
  PROCESSING = "PROCESSING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export enum AML_REQUEST_ACTION {
  FUNDED = "FUNDED",
  APPROVE_REQUEST = "APPROVE_REQUEST",
  EXECUTE = "EXECUTE",
  ACCEPT_QUOTE = "ACCEPT_QUOTE",
}

export const StatusType: Record<ORDER_STATUS, string> = {
  NEW: "Новый",
  PROCESSING: "В обработке",
  SUCCESS: "Успешно",
  FAILED: "Неуспешно",
};

export interface AmlRiskMessage {
  message: string;
  description?: string;
  type: "success" | "info" | "warning" | "error";
}

export const ORDER_MAP: Record<Exclude<SortOrder, null>, "asc" | "desc"> = {
  ascend: "asc",
  descend: "desc",
};

export const REVERSE_ORDER_MAP: Record<"asc" | "desc", Exclude<SortOrder, null>> = {
  asc: "ascend",
  desc: "descend",
};

/**
 * Специальный тип для запросов если TS ругается
 */
export type BidListResponse = {
  content: TBidDto[];
  size: number;
  totalPages: number;
  totalElements: number;
};
